import { render, staticRenderFns } from "./ResetPasswordButton.vue?vue&type=template&id=81516544&"
import script from "./ResetPasswordButton.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordButton.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordButton.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports